// Catégories d'âge, de la plus jeune à la plus âgée. Valeurs FFBB par défaut ;
// chaque club pourra les adapter (D-027). « Loisir » est hors échelle.
export const CATEGORIES = ['U7', 'U9', 'U11', 'U13', 'U15', 'U17', 'U18', 'U20', 'Seniors', 'Loisir'] as const;

const LADDER = CATEGORIES.filter(c => c !== 'Loisir') as string[];

/**
 * Catégories où une joueuse peut être surclassée (D-026) : celles au-dessus de
 * la sienne. Catégorie inconnue ou absente : toutes.
 */
export function categoriesAbove(category: string | null | undefined): string[] {
  const i = category ? LADDER.indexOf(category) : -1;
  return i < 0 ? [...LADDER] : LADDER.slice(i + 1);
}
